/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const paginatedAccountFeatureFlagListListResultsItemNameMax = 255;

export const paginatedAccountFeatureFlagListListResultsItemCodeMax = 255;

export const PaginatedAccountFeatureFlagListList = zod.strictObject({
    count: zod.number().optional(),
    has_next: zod.boolean().optional(),
    has_previous: zod.boolean().optional(),
    limit: zod.number().optional(),
    page: zod.number().optional().describe('The current page number'),
    pages: zod.number().optional().describe('The total number of pages'),
    results: zod
        .array(
            zod.strictObject({
                name: zod
                    .string()
                    .max(paginatedAccountFeatureFlagListListResultsItemNameMax),
                code: zod
                    .string()
                    .max(paginatedAccountFeatureFlagListListResultsItemCodeMax),
                created_at: zod.iso.datetime({ offset: true }),
                updated_at: zod.iso.datetime({ offset: true }),
            }),
        )
        .optional(),
});

export type PaginatedAccountFeatureFlagListList = zod.input<
    typeof PaginatedAccountFeatureFlagListList
>;
export type PaginatedAccountFeatureFlagListListOutput = zod.output<
    typeof PaginatedAccountFeatureFlagListList
>;
